import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["item", "type", "onAppend"];
import { parseAlgoliaHitHighlight } from '@algolia/autocomplete-preset-algolia';
import React, { memo } from 'react';
import { AppendButton, ArrowIcon, Icon16, Icon24, ParentContainer, Query, QueryContainer, SearchItemContainer, Text, TextHighlighted } from './SearchItem.styles';
import AppendSvg from './assets/Append.svg';
import RecentSvg from './assets/Recent.svg';
import RightArrowSvg from './assets/RightArrow.svg';
import SearchSvg from './assets/Search.svg';
export let SearchItemType = /*#__PURE__*/function (SearchItemType) {
  SearchItemType["SEARCH"] = "search";
  SearchItemType["RECENT"] = "recent";
  return SearchItemType;
}({});
// Component to highlight inout query in suggestions
function Highlight(_ref) {
  let {
    hit,
    attribute
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, null, parseAlgoliaHitHighlight({
    hit,
    attribute
  }).map((_ref2, index) => {
    let {
      value,
      isHighlighted
    } = _ref2;
    if (isHighlighted) {
      return /*#__PURE__*/React.createElement(TextHighlighted, {
        key: index
      }, value, " ");
    }
    return value;
  }));
}
const MemoizedHighlight = /*#__PURE__*/memo(Highlight);
export function SearchItem(_ref3) {
  let {
      item,
      type,
      onAppend
    } = _ref3,
    autocompleteProps = _objectWithoutProperties(_ref3, _excluded);
  const icon = type === SearchItemType.SEARCH ? /*#__PURE__*/React.createElement(Icon16, {
    src: SearchSvg,
    alt: type
  }) : /*#__PURE__*/React.createElement(Icon16, {
    src: RecentSvg,
    alt: type
  });
  return /*#__PURE__*/React.createElement(ParentContainer, null, /*#__PURE__*/React.createElement(SearchItemContainer, _extends({
    className: "search-item-container"
  }, autocompleteProps), /*#__PURE__*/React.createElement(Query, {
    role: "button",
    type: "button",
    "aria-label": item.query
  }, /*#__PURE__*/React.createElement(QueryContainer, null, icon, type === SearchItemType.SEARCH ? /*#__PURE__*/React.createElement(MemoizedHighlight, {
    hit: item,
    attribute: "query"
  }) : /*#__PURE__*/React.createElement(Text, null, item.query)), /*#__PURE__*/React.createElement(ArrowIcon, {
    className: "suggestion-arrow-icon",
    src: RightArrowSvg,
    alt: "select"
  }))), /*#__PURE__*/React.createElement(AppendButton, {
    className: "append-button",
    role: "button",
    type: "button",
    "aria-label": "Append query to search bar",
    onClick: () => onAppend(item)
  }, /*#__PURE__*/React.createElement(Icon24, {
    src: AppendSvg,
    alt: "append"
  })));
}